import { Component, Input, OnInit } from '@angular/core';
@Component({
    selector: 'simple-icons-deezer',
    template: `<svg class="simple-icons {{ className }}" [style.width]="size" [style.height]="size" [style.fill]="color" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><title>Deezer icon</title><path d="M18.81 4.16v3.03H24V4.16h-5.19zM6.27 8.38v3.027h5.189V8.38h-5.19zm12.54 0v3.027H24V8.38h-5.19zM6.27 12.594v3.027h5.189v-3.027h-5.19zm6.271 0v3.027h5.19v-3.027h-5.19zm6.27 0v3.027H24v-3.027h-5.19zM0 16.81v3.029h5.19v-3.03H0zm6.27 0v3.029h5.189v-3.03h-5.19zm6.271 0v3.029h5.19v-3.03h-5.19zm6.27 0v3.029H24v-3.03h-5.19Z"/></svg>`,
    styles: []
})
export class SimpleIconsDeezerComponent implements OnInit {
    @Input() size: string = '100%';
    @Input() color: string = '#FEAA2D';
    @Input() className: string = 'simple-icons-deezer'
    constructor() {}
    ngOnInit(): void {}
}
